import co from 'co'

const OSSConfig = {
    uploadHost: localStorage.getItem("keyossHost"), //OSS上传地址
    type: 'scs',
    ossParams: {
        region: 'oss-cn-beijing',
        success_action_status: '200', // 默认200
        accessKeyId: 'LTAI4GKvfHuroQuVmpa6z4GS',
        accessKeySecret: 'AJAtI0QC6W5umokloFlaoXVYWFKMvx',
        bucket: localStorage.getItem("keyossbucket"),
    },
}

function random_string(len) {
    len = len || 32;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

/**
 *
 * @param event 上传图片的资源路径
 * @param type 图片资源类型
 * @param dir oss要保存的文件夹
 * @returns {OSS文件路径}
 */

function uploadOSS(event, type,dir = localStorage.getItem("keyossfile")) {
    return new Promise((resolve, reject) => {
        var client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: OSSConfig.ossParams.accessKeyId,
            accessKeySecret: OSSConfig.ossParams.accessKeySecret,
            endpoint: 'https://' + 'oss-cn-beijing.aliyuncs.com',
            bucket: localStorage.getItem("keyossbucket"),
        });
        var file;
        if (type == 0) {
            file = event;
            var randomName = `${dir}${random_string(6)}_${file.name}`;
        } else {
            file = event.target.files[0];
            var randomName = `${dir}${random_string()}.mp4`;
        }
        co(function* () {
            var result = yield client.multipartUpload(randomName, file);
            // console.log(`${OSSConfig.uploadHost}/${result.name}`);
            // resolve(`${OSSConfig.uploadHost}/${result.name}`);
            resolve(localStorage.getItem("keyossHost")+`${result.name}`); // 去掉斜杠
        }).catch(function (err) {
            reject(err);
        });
    });
}

export { uploadOSS }


// WEBPACK FOOTER //
// ./src/utils/oss.js